import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const forceChangePassword = createAsyncThunk(
  "login/forceChangePassword",
  async (data, thunkAPI) => {
    const { new_password, handleSuccess, handleError } = data;
    try {
      const resp = await axios.post(
        `${process.env.REACT_APP_BASE_URL}api/users/force-change-password`,
        { new_password },
        {
          headers: {
            Authorization: "Bearer " + localStorage.token,
            "Content-Type": "application/json",
          },
        }
      );
      if (handleSuccess) {
        handleSuccess(resp.data?.message || "Password changed successfully!");
      }
      return resp.data;
    } catch (error) {
      if (error.response) {
        if (handleError) {
          handleError(error.response.data.message);
        }
        return thunkAPI.rejectWithValue(error.response.data.message);
      } else {
        if (handleError) {
          handleError(error.message);
        }
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);
